import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from "recharts";

interface RankData {
  companyName: string;
  amount: number;
}

interface SalesRankChartProps {
  data: RankData[];
}

// 회사별 색상 팔레트
const COLORS = [
  "#52C41A", // Teal/Green
  "#FA8C16", // Coral/Orange
  "#1890FF", // Dark blue
  "#FADB14", // Light brown/Tan
  "#CF1322", // Dark red
  "#73D13D", // Lime green
  "#389E0D", // Dark olive green
  "#D3ADF7", // Light purple
  "#0958D9", // Medium blue
  "#FF7A45", // Reddish-orange
  "#52C41A", // Dark green
  "#D9D9D9", // Light gray (기타)
];

export default function SalesRankChart({ data }: SalesRankChartProps) {
  // 금액 포맷팅
  const formatAmount = (amount: number) => {
    return `${(amount / 100000000).toFixed(1)}억`;
  };

  const maxNameLength = Math.max(...data.map(item => item.companyName.length), 0);
  const dynamicWidth = Math.max(10, Math.min(75, maxNameLength * 8)); // 최소 80, 최대 200, 글자당 8px

  return (
    <div className="w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          layout="vertical"
          margin={{
            top: 20,
            right: 40,
            left: dynamicWidth + 10,
            bottom: 20,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#E8E8E8" vertical={true} />
          <XAxis
            type="number"
            tick={{ fill: "#666", fontSize: 12 }}
            axisLine={{ stroke: "#E8E8E8" }}
            tickLine={{ stroke: "#E8E8E8" }}
            hide
          />
          <YAxis
            type="category"
            dataKey="companyName"
            tick={{ fill: "#60646C", fontSize: 12 }}
            axisLine={{ stroke: "#E8E8E8" }}
            tickLine={{ stroke: "#E8E8E8" }}
            width={dynamicWidth}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #E8E8E8",
              borderRadius: "4px",
            }}
            formatter={(value: number) => formatAmount(value)}
          />
          <Bar dataKey="amount" fill="#52C41A" barSize={30} radius={[0, 4, 4, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
